/**
 * Created by fky on 3/3/2017.
 */
'use strict';

angular.module('dashboard.fmsDashboard', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('FMSVehicleWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.fmsVehicle.vehicleList';
          },
          description: function () {
            return 'dashBoard.fleetManagement.fmsVehicle.description';
          }
        },
        controller: 'FMSVehicleListCtrl',
        templateUrl: 'components/dashboard/fmsVehicle/fmsVehicleWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          vehicleGroup: null,
          noOfGridRows: ''
        },
        edit: {
          templateUrl: 'components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.html',
          reload: false,
          controller: 'FMSVehicleEditCtrl'
        }
      });
  }).service('FMSVehicleWidgetService', function (crudService) {

    this.getEventDetailAllSummaryList = function (vechileGroup, isDataRefresh) {
      var requestParam = {
        statusCode: 'all',
        vehicleGroup: vechileGroup,
        dataRefresh: isDataRefresh,
        timeTo: '-0d',
        timeFrom: ''
      };

      var param = {
        'filter': JSON.stringify(requestParam)
      };
      var data = crudService.customGET('overview', 'eventdetailallsummary', param);
      //console.log('Data fetch completed');
      return data;
    };

    this.getVehicleEventDetailAllList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'EventDetailAll'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'vehicleeventdetailfms/' + deviceId, param);
    };

    this.getVehicleTellTalesList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'DeviceTellTaleDetails'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'vehicleeventdetailtelt/' + deviceId, param);
    };



  }).controller('FMSVehicleListCtrl', function ($scope, config, widgetSettingsCreatorService, vehicleListWidgetService, stateManagerService, $rootScope, $timeout, $translate, commonTrackService, $filter, AuthenticationService, localStorageService, $state, FMSVehicleWidgetService, errorHandlingService, toastService, $interval) {
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.selectedFunction = '';
    $scope.isDataAvailable = true;
    $scope.activeTab = 0;
    $scope.uuidForElement =  $scope.$id;
    $scope.vehicleAllDetailTab = {
      disable: true
    };

    $scope.dataSet = {
      deviceID: null,
      driverID: null,
      lastUpdateRequest: 0
    };

    $scope.vehicleAllDetail = {
      date: {
        startDate: new Date().setHours(0, 0, 0, 0),
        endDate: new Date()
      }
    };
    var _lastRefreshTimeS = null;
    //var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
    var counterSeconds = 60;
    var counterTimeout;
    var gtsUserSettings = null;
    var dateRangePickerSettings = {};
    var rowSize = vehicleListWidgetService.getRowSize();
    var vehicleListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };
    $scope.vehicleListdataAdapter = new $.jqx.dataAdapter(vehicleListSource);
    var fmsContextMenu = {};

    var isFmsCtxInitialized = false;

    $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
    });

    $scope.telltaleComboBoxSetting = widgetSettingsCreatorService.createComboxSettings({
      source: ['Blue', 'Yellow', 'Red'],
      multiSelect: true,
      placeHolder: 'Select TellTale Filter'
    });

    $scope.customGridProperties = {
      fmsVehicle: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      },
      vehicleAllDetails: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      },
      vehicleTelltaleDetails: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      }
    };

    var moreFunctionSource = [
      {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
        execute: 'createMessageEvent',
        value: 'sendMsg'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
        execute: 'createCommandEvent',
        value: 'sendCommand'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
        value: 'showDashboard',
        execute: 'showDashboard'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
        value: 'showDriverDashboard',
        execute: 'showDriverDashboard'
      }/*, {
      name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
      value: 'showPortalCommand',
      execute: 'showPortalCommand'
    }*/
    ];


    $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();

    $scope.moreFuctionSetting.source = moreFunctionSource;

     /**
     *  temporay private variable  to store some global values , created to avoid using config object .
     *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
     */
      var _tmpConfig ={};

    $scope.moreFunctionsOnChange = function (event) {
      if (event.args.item.originalItem.execute) {
        _commonFunction[event.args.item.originalItem.execute]();
      }
      $('#moreFunDropDown').jqxDropDownList('clearSelection');
    };

    function createMessageEvent() {
      $rootScope.$broadcast('newMsgEvent', {});
    }

    function createCommandEvent() {
      $rootScope.$broadcast('newCommandEvent', {});
    }

    function showDriverDashboard() {
      $state.go('driverdashboard');
    }

    function showDashboard() {
      $state.go('betotrack.dashboard');
    }


    function showPortalCommand() {
      $state.go('portalcommand');
    }

    var _commonFunction = {
      'createMessageEvent': createMessageEvent,
      'createCommandEvent': createCommandEvent,
      'showDashboard': showDashboard,
      'showDriverDashboard': showDriverDashboard,
      'showPortalCommand': showPortalCommand
    };

    var _contextSourceObj = {
      fmsCtxSource: [
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
          execute: createMessageEvent
        },
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
          execute: createCommandEvent
        },
        {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
          execute: showDashboard
        }, {
          label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
          execute: showDriverDashboard
        }/*, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
        execute: showPortalCommand
      }*/
      ]
    };


    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(110);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      source: _contextSourceObj.fmsCtxSource, popupZIndex: 999999
    });
    var loadGtsUserSettings = function () {
      return commonTrackService.getGtsUserSettings(false).then(function (userSettings) {
        gtsUserSettings = userSettings;
      });
    };

    var loadGtsAccountSettings = function () {
      return commonTrackService.getGtsAccountSettings(true);
    };
    loadGtsAccountSettings();
    loadGtsUserSettings();

    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
        if (vechileGroupList.length > 0) {
          $scope.vehicleGroupSettings.source = vechileGroupList;
          var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) { // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = config.vehicleGroup;
          }

          if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
            if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {// validate the local storage group is still valid ( group can change based on login )
              $scope.vehicleGroup = cachedGroup;
              config.vehicleGroup = cachedGroup;
            }
          }

          if (!$scope.vehicleGroup) {
            $scope.vehicleGroup = vechileGroupList[0].groupID;
          }

        }
      });
    };
    loadVehicleGroup().finally(function () {
      $scope.dataLoadingFinished = true;
      if ($scope.vehicleGroup) {
        loadEventDetailAllSummaryList($scope.vehicleGroup, true);
      }

    });

    var loadEventDetailAllSummaryList = function (vehicleGroup, dataRefresh, isAutorefresh) {
      //console.log( 'loadEventDetailAllSummaryList() : - Request to Server At :'+ moment().format('HH:mm:ss.SSS'));

      $scope.stop();
      //statusCode = statusCode !== undefined && statusCode !== null ? statusCode : 'all';
      return FMSVehicleWidgetService.getEventDetailAllSummaryList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
        //console.log( 'loadEventDetailAllSummaryList() : Data Returned from server - At : '+ moment().format('HH:mm:ss.SSS'));

        // if(!vehicleResult.dataList || vehicleResult.dataList.length === 0){
        //   //Looking into cause of no result being returned
        //   console.log(vehicleResult);
        // }

        if (vehicleResult.dataList) {
          $scope.isDataAvailable = true;

          if (dataRefresh) {
            $scope.customGridProperties.fmsVehicle.columns = commonTrackService.getColumnProperties(vehicleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleResult.columnTranslation, { moduleName: 'fmsVehicle' });

            vehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'fmsVehicleList', vehicleListSource);

            vehicleListSource.localdata = vehicleResult.dataList;
            _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
            var _preferedDeviceId = gtsUserSettings.preferredDeviceID;
            var _preferedVehicleRowIndex = null;
            // users preferred vehicle selection from user settings.
            if (_preferedDeviceId && dataRefresh && $state.previous.name === 'login') {
              for (var i = 0; i < vehicleListSource.localdata.length; i++) {
                if (_preferedDeviceId === vehicleListSource.localdata[i].deviceid) {
                  _preferedVehicleRowIndex = i;
                  break;
                }
              }
            }
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList') };
            $scope.fmsVehicleListGridSettings = commonTrackService.getGridSettings('fmsVehicle', $scope.customGridProperties.fmsVehicle, _preferedVehicleRowIndex, _additionalProperties);

            $scope.fmsVehicleListGridSettings.source = $scope.vehicleListdataAdapter;
            //console.log( 'loadEventDetailAllSummaryList() : - Source adaptor attached to grid  At :  '+ moment().format('HH:mm:ss.SSS'));

            $scope.createFmsVehicleList = true;
          }
          else {
            vehicleListSource.localdata = vehicleResult.dataList;
            _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'fmsVehicleList');
            //console.log( 'loadEventDetailAllSummaryList() : - Source update Bound Data At :  '+ moment().format('HH:mm:ss.SSS'));
          }
        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {

        $scope.counter = counterSeconds;
        $scope.createFmsVehicleList = true;

        if (($scope.isDataAvailable && !counterTimeout) || ($scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled')) {
          $scope.startCounter();
        } else {
          $scope.stop();
        }

        // send row select event after evey request to update the broadcastEventData[selected grid row details].

        // send row select event after evey request to update the broadcastEventData[selected grid row details].

        var rows = $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrows');
        var _lastSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
        if (_lastSelectedRowIndex < 0) {
          broadcastEventData.selectedRow = null;
          broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
          broadcastEventData.isDataFromTab = true;
          broadcastEventData.tabNumber = $scope.activeTab;
          broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
          $rootScope.$broadcast('rowSelected', broadcastEventData);

          return;
        }
        if (isAutorefresh && _lastSelectedRowIndex || !dataRefresh && _lastSelectedRowIndex || _lastSelectedRowIndex === 0) {
          broadcastEventData.isRefreshStarted = true;
          $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('selectrow', _lastSelectedRowIndex);
        }
        //console.log( 'loadEventDetailAllSummaryList() : Request finalization method finished At : '+ moment().format('HH:mm:ss.SSS'));
      });
    };







    var broadcastEventData = {
      selectedRow: {},
      selectedVehicleGroup: '',
      selectedVehicleGroupLabel: '',
      eventSource: ''
    };

    $scope.vehicleGroupComboChange = function (event) {
      var vehicleGroup = event.args.item;
      // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
      if (config.vehicleGroup !== vehicleGroup.value) {
        if ($scope.fmsVehicleListGridSettings) {
          loadEventDetailAllSummaryList(vehicleGroup.value, $scope.fmsVehicleListGridSettings.columns.length > 0 ? false : true);
        }
      }
      if (vehicleGroup) {
        broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
        broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
        config.vehicleGroup = vehicleGroup.value;
        var loginid = AuthenticationService.GetLoginID();
        localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, config.vehicleGroup);
        commonTrackService.setLastSelectedGroup(vehicleGroup);
        broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = $scope.activeTab;
        $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
      }
    };

    $scope.gridRowClickHandler = function (event) {
      if (event.args.rightclick) {
        if (!isFmsCtxInitialized) {
          fmsContextMenu = $('#'+$scope.uuidForElement+'_betoTrack_fmsVehicleCtx').jqxMenu($scope.ctxMenuSettings);
          $('#'+$scope.uuidForElement+'_betoTrack_fmsVehicleCtx').on('itemclick', fmsVehicleListContextHandler);
          isFmsCtxInitialized = true;
        }
        commonTrackService.initGridRightClickContextMenu(event, fmsContextMenu);
      }
    };


    function fmsVehicleListContextHandler(event) {
      commonTrackService.executeContextMenuClick(event, 'fmsCtxSource', _contextSourceObj);
    }


    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          if ($scope.activeTab === 1) {
            $scope.vehicleAllDetail.date.startDate = moment($scope.vehicleAllDetail.date.startDate);
            $scope.vehicleAllDetail.date.endDate = moment($scope.vehicleAllDetail.date.endDate);

            _tmpConfig.startDate = $scope.vehicleAllDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
            _tmpConfig.endDate = $scope.vehicleAllDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
            loadVechileEventDetailList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
          }
        }
      }
    };

    commonTrackService.getDatePickerDetails().then(function (settings) {
      var tab = $scope.activeTab === 1 ? 'EventDetailAll' : undefined;
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings,tab));
      dateRangePickerSettings = settings;
    });

    function _initRequestData(dateRangeScopeName, formatType) {
      var _typeOfGridRow = 'selectedRow';
      if (broadcastEventData[_typeOfGridRow].deviceid) {
        _tmpConfig.deviceId = broadcastEventData[_typeOfGridRow].deviceid;
        var _serverTimeFormat = {};
        _serverTimeFormat._tmpEndDate = commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, broadcastEventData[_typeOfGridRow].time, formatType);
        _serverTimeFormat._tmpStartDate = commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, '00:00:00', formatType);

        $scope[dateRangeScopeName] = {
          date: {
            startDate: new Date(_serverTimeFormat._tmpStartDate.replaceAt(10, ' ')),
            endDate: new Date(_serverTimeFormat._tmpEndDate.replaceAt(10, ' '))
          }
        };

        return _serverTimeFormat;
      }
      else {
        return null;
      }
    }

    $scope.stopAutoRefresh = function (event, type) {
      if (event) {
        commonTrackService.getRefreshStartStopfunction($scope, true, true, loadEventDetailAllSummaryList, 'vehicleGroupComboBox', false, true, event)();
      } else {
        if (type === 'start') {
          $scope.isTimerStated = false;
        } else {
          $scope.isTimerStated = true;
        }
        commonTrackService.getRefreshStartStopfunction($scope, true, true, loadEventDetailAllSummaryList, 'vehicleGroupComboBox', false, true)();
      }
    };

    $scope._initFMSVehicleTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

      $rootScope.$broadcast('tabEvent', {
        'tabName': 'FMSVehicle',
        dashboardName: 'dashboard.fmsDashboard',
        isDataFromTab: true,
        tabNumber: 0,
        deviceId: _tmpConfig.deviceId
      });
      if (!$scope.isStopedByUser) {
        $scope.stop();
        $scope.stopAutoRefresh(null, 'start');
      }
      broadcastEventData.lastTabName = 'FMSVehicle';
    };

    $scope._initVehicleAllDetailTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,'EventDetailAll'));

      $scope.stopAutoRefresh(null, 'stop');
      var timeFormat = _initRequestData('vehicleAllDetail');
      if (timeFormat) {
        var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
        tmpFromDate.subtract({ hours: 2 });
        timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
        $scope.vehicleAllDetail.date.startDate = timeFormat._tmpStartDate;
        loadVechileEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleAllDetails.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
      }
    };

    $scope._initVehicleTellTaleTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

      $scope.stopAutoRefresh(null, 'stop');
      var timeFormat = _initRequestData('vehicleTellTale');
      if (timeFormat) {
        $scope.vehicleTellTale.date.startDate = timeFormat._tmpStartDate;
        loadvehicleTellTaleList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleTelltaleDetails.columns.length > 0 ? false : true, timeFormat._tmpEndDate, timeFormat._tmpEndDate);
      }
    };

    // vehicle details tab functions
    var loadVechileEventDetailList = function (deviceId, dataRefresh, startDate, endDate) {
      return FMSVehicleWidgetService.getVehicleEventDetailAllList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEventDetailResult) {
        if (vehicleEventDetailResult.dataList) {
          if (dataRefresh) {
            $scope.customGridProperties.vehicleAllDetails.columns = commonTrackService.getColumnProperties(vehicleEventDetailResult.gridSettings.overviewListGrids[0].columnProperties, vehicleEventDetailResult.columnTranslation, { moduleName: 'vehicleAllDetails' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleAllDetailsTab.vehicleAllDetails') };
            $scope.vehicleAllDetailsGridSettings = commonTrackService.getGridSettings('vehicleAllDetails', $scope.customGridProperties.vehicleAllDetails, null, _additionalProperties);
            $scope.vehicleAllDetailsGridSettings.source = vehicleEventDetailResult.dataList;
          } else {
            $scope.vehicleAllDetailsGridSettings.source = vehicleEventDetailResult.dataList;
          }
          if ($scope.activeTab === 1) {
            $rootScope.$broadcast('tabEvent', {
              'tabName': 'vechileEventDetail',
              'repoVehicle': deviceId,
              'startDate': startDate,
              'endDate': endDate,
              dashboardName: 'dashboard.fmsDashboard',
              isDataFromTab: true,
              tabNumber: 1
            });
          }


          // expecting map to be ready after 4 seconds and send row select which will update map for pushpin
          $timeout(function () {
            var rowindex = $('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getselectedrowindex');
            if (rowindex > vehicleEventDetailResult.dataList.length - 1 || rowindex < 0) {
              rowindex = 0;
            }
            $('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('selectrow', rowindex);
          }, 3000);
        }
      }).finally(function () {
        $scope.createVehicleAllDetilListGrid = true;
        broadcastEventData.lastTabName = 'vehicleAllDetails';


      });
    };

    $scope.isTelltaleAvailable = false;

    // vehicle telltake tab function
    var loadvehicleTellTaleList = function (deviceId, dataRefresh, startDate, endDate) {
      return FMSVehicleWidgetService.getVehicleTellTalesList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleTellTaleResult) {
        if (vehicleTellTaleResult.dataList) {
          $scope.isTelltaleAvailable = true;
          if (dataRefresh) {
            $scope.customGridProperties.vehicleTelltaleDetails.columns = commonTrackService.getColumnProperties(vehicleTellTaleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleTellTaleResult.columnTranslation, { moduleName: 'vehicleTellTales' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleTellTalesTab.vehicleTellTales') };
            $scope.vehicleTellTalesGridSettings = commonTrackService.getGridSettings('vehicleTellTales', $scope.customGridProperties.vehicleTelltaleDetails, null, _additionalProperties);
            $scope.vehicleTellTalesGridSettings.source = vehicleTellTaleResult.dataList;
          } else {
            $scope.vehicleTellTalesGridSettings.source = vehicleTellTaleResult.dataList;
          }


          if ($scope.activeTab === 2) {
            // SCL-1340
            $rootScope.$broadcast('telltaleDataUpdate', {
              'tabName': 'vehicleTellTale',
              deviceId: _tmpConfig.deviceId,
              dashboardName: 'dashboard.fmsDashboard',
              isDataFromTab: true,
              date: $scope.telltaleData.date,
              dateTimespan: $scope.telltaleData.timestamp,
              tabNumber: 2
            });

            var selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
            var selectedFmsDashboardRow = {};
            if (selectIndex > -1) {
              selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
            }

            var tellTaleRowData = {};

            stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);
            stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 2 + '_selectedRow', tellTaleRowData, true);

            $rootScope.$broadcast('dataStateUpdate', {
              widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
              dashboardName: 'dashboard.fmsDashboard',
            });
          }

          // expecting map to be ready after 4 seconds and send row select which will update map for pushpin
          $timeout(function () {
            var rowindex = $('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getselectedrowindex');
            if (rowindex > vehicleTellTaleResult.dataList.length - 1 || rowindex < 0) {
              rowindex = 0;
            }
            $('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('selectrow', rowindex);
            tellTaleRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getrowdata', rowindex);
            stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 2 + '_selectedRow', tellTaleRowData, true);


          }, 3000, false);
        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isTelltaleAvailable = false;
        }
      }).finally(function () {
        $scope.createTellTaleListGrid = true;
        broadcastEventData.lastTabName = 'vehicleTellTales';
      });
    };

    $scope.rowSelectHandler = function (event) {
      var _vehicleDetailRow = {};
      _vehicleDetailRow.selectedRow = event.args.row;
      _vehicleDetailRow.selectedRow.deviceid = broadcastEventData.selectedRow.deviceid;

      _vehicleDetailRow.gridName = 'vehicleAllDetail';
      _vehicleDetailRow.updateMapUrl = false;
      _vehicleDetailRow.updateWidgetTitle = false;
      _vehicleDetailRow.isTermoWidgetDependent = true; // SCL-1496
      if ($scope.activeTab === 1) {
        _vehicleDetailRow.dashboardName = 'dashboard.fmsDashboard';
        _vehicleDetailRow.isDataFromTab = true;
        _vehicleDetailRow.gridName = 'vehicleDetail'; // event detail widget is triggered by this gridName
        _vehicleDetailRow.tabNumber = $scope.activeTab;
        _vehicleDetailRow.eventType = 'fms_vehicle_list_row_select';
        $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
        if (event.type === 'rowselect') {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'vehicleMap');
        }
      } else if ($scope.activeTab === 2) {
        _vehicleDetailRow.dashboardName = 'dashboard.fmsDashboard';
        _vehicleDetailRow.isDataFromTab = true;
        _vehicleDetailRow.tabNumber = $scope.activeTab;
        $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
      }

      var row = event.args.row;
      $scope.dataSet.deviceID = row.deviceid;
      $scope.dataSet.driverID = row.driverid;

      //var reportDatetime = commonTrackService.formatReportDateTime(row.date, row.time);

      stateManagerService.updateValue('fmsVehicleWidget', 'deviceID', $scope.dataSet.deviceID, true);
      stateManagerService.updateValue('fmsVehicleWidget', 'driverID', $scope.dataSet.driverID, true);
      // stateManagerService.updateValue('fmsVehicleWidget', 'startDate', reportDatetime, true);
      // stateManagerService.updateValue('fmsVehicleWidget', 'endDate', reportDatetime, true);
      stateManagerService.updateValue('fmsVehicleWidget', 'rowData', _vehicleDetailRow, false);
      stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, true);


      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
        dashboardName: 'dashboard.fmsDashboard',
      });

    };


    $scope.startCounter = function () {
      $scope.stop();
      $scope.isTimerStated = true;
      $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
      if ($scope.counter - 1 >= 1) {
        $scope.counter--;
        counterTimeout = $interval($scope.startCounter, 1000);
      } else {
        var _vehicleGroup = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
        if (_vehicleGroup && _vehicleGroup.value) {
          loadEventDetailAllSummaryList(_vehicleGroup.value, false, true);
        }
        else {
          var errorObj = {
            type: 'F',
            message: $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleGroupValidation')
          };
          toastService.showErrorToast(errorObj);
          $scope.stop();
        }
      }
    };

    $scope.stop = function () {
      $interval.cancel(counterTimeout);
    };
    var _lastSelectedRowIndex = -1;
    // update vehicle map widget  based on selected vechile id
    $scope.fmsVehicleListSelectHandler = function (event) {
      if (event.type === 'rowselect' && event.args.row) {
        _lastSelectedRowIndex = event.args.rowindex;
        broadcastEventData.selectedRow = event.args.row;
        broadcastEventData.updateMapUrl = broadcastEventData.lastTabName === 'vehicleAllDetails' ? false : true;
        broadcastEventData.updateWidgetTitle = true;
        broadcastEventData.eventType = 'fms_vehicle_list_row_select';
        if ($scope.activeTab === 0) {
          broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
          broadcastEventData.isDataFromTab = true;
          broadcastEventData.tabNumber = $scope.activeTab;
          broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
          $rootScope.$broadcast('rowSelected', broadcastEventData);
          $rootScope.$broadcast('init-widget-data-from-server', { deviceID: event.args.row.deviceid, selectedRow: event.args.row });
        }
        commonTrackService.setLastLocatioWidgetData(broadcastEventData);
        var pushPinIndex = event.args.row.index - 1;
        $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
        $scope.vehicleAllDetailTab.disable = false;

        //
        $scope.telltaleData = {};
        $scope.telltaleData.timestamp = event.args.row.telltaletimestamp;
        $scope.telltaleData.hasdate = $scope.telltaleData.timestamp > 0;
        $scope.telltaleData.date = ($scope.telltaleData.hasdate ? moment.unix($scope.telltaleData.timestamp) : moment(0)).format('YYYY/MM/DD/HH:mm:ss');
        // $scope.vehicleTellTaleTab.disable = false;
        //save
        var loginid = AuthenticationService.GetLoginID();

        $scope.dataSet.deviceID = broadcastEventData.selectedRow.deviceid;
        $scope.dataSet.driverID = broadcastEventData.selectedRow.driverid;

        // var reportDatetime = commonTrackService.formatReportDateTime(broadcastEventData.selectedRow.date, broadcastEventData.selectedRow.time);

        stateManagerService.updateValue('fmsVehicleWidget', 'deviceID', $scope.dataSet.deviceID, true);
        stateManagerService.updateValue('fmsVehicleWidget', 'driverID', $scope.dataSet.driverID, true);
        stateManagerService.updateValue('fmsVehicleWidget', 'rowData', broadcastEventData, false);
        stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', broadcastEventData.selectedRow, true);

        $rootScope.$broadcast('dataStateUpdate', {
          widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
          dashboardName: 'dashboard.fmsDashboard',
        });

        localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
          'deviceid': broadcastEventData.selectedRow.deviceid,
          'driverid': broadcastEventData.selectedRow.driverid
        });
      }
    };


    //job-vent listener
    var jobEvent = $scope.$on('job-event', function (event, data) {
      var _eventDateTime = new Date(data.eventTimeStamp * 1000);
      var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
      // console.log('data.eventTimeStamp - ' + _eventDateTime);
      // console.log('grid refresh time - ' + _gridRefreshDateTime);
      // console.log(_eventDateTime > _gridRefreshDateTime);
      if (_eventDateTime > _gridRefreshDateTime) {
        var _tmpGridsource = vehicleListSource.localdata;
        for (var i = 0; i < _tmpGridsource.length; i++) {
          if (_tmpGridsource[i].deviceid === data.dev) {
            _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
            _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
            _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
            _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
            _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
            _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
            $scope.fmsVehicleListGridSettings.source = _tmpGridsource;
            $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('updatebounddata', 'data');
            break;
          }
        }
      }
    });
    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      var tab = $scope.activeTab === 1 ? 'EventDetailAll' : undefined;
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,tab));
    });

    var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
      $rootScope.$broadcast('vehicleMap_res_current_context', {
        dashboardName: 'dashboard.fmsDashboard',
        isDataFromTab: true,
        tabNumber: $scope.activeTab,
        currentWidgetContextData: broadcastEventData,
        dataLoadingFinished: $scope.dataLoadingFinished,
        isDataAvailable: $scope.isDataAvailable
      });
    });
    var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
      $rootScope.$broadcast('fleetMap_res_current_context', {
        dashboardName: 'dashboard.fmsDashboard',
        vehicleGroup: config.vehicleGroup
      });
    });

    // stateManagerService
    // Used when unkown dependant (child) widget requests data.
    // Since this is a global request for data, widget needs to check if the,
    // requested fields is anything it can provide before updating.
    // Will call the dataStateUpdate event if it updates data.
    var updateRequest = $scope.$on('reqDataUpdate', function () {
      var selectedRowData = {};
      var selectIndex = -1;
      var selectedFmsDashboardRow = {};

      switch ($scope.activeTab) {
        case 0:
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
          }
          break;
        case 1:
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getrowdata', selectIndex);
          }
          break;
        case 2: //uses same row select Logic
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getrowdata', selectIndex);
          }

          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
          }

          break;
      }

      // push the changes to stateManagerService

      if ($scope.activeTab > 0) {
        stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', selectedRowData, true);
        stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);

      } else if (!_.isEmpty(selectedFmsDashboardRow)) { // first tab must always return a valid selected values
        stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);
      }
      $rootScope.$broadcast('resDataUpdate',
        {
          widget: 'fmsVehicleWidget',
          activeTab: $scope.activeTab,
          dashboardName: 'dashboard.fmsDashboard',
          timespan: new Date().getTime()
        });
    });


    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    // Google maps takes focus if the auto refresh enabled
    // Auto refresh must be stoped if the chat window is open to solve focus switching
    var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
      // stop the auto refresh only if an existing timer is detected under the last location tab
      // bug 105133
      if ($scope.isTimerStated && $scope.activeTab === 0) {  // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
        $scope.stopAutoRefresh(null, 'stop');
      }
    });
    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    //  restart the auto refresh is the chat window is closed
    var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
      // bug 105133
      if (!$scope.isTimerStated && $scope.activeTab === 0) { // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
        $scope.stopAutoRefresh(null, 'start');
      }
    });

    $scope.$on('$destroy', function () {

      if(chatWindowOpenEvent){
        chatWindowOpenEvent();
      }
      if(chatWindowCloseEvent){
        chatWindowCloseEvent();
      }

      updateDateRangeInternalDateEvent();

      if ($scope.vehicleListdataAdapter) {
        delete $scope.vehicleListdataAdapter;
      }
      if ($scope.fmsVehicleListGridSettings && $scope.fmsVehicleListGridSettings.source) {
        delete $scope.fmsVehicleListGridSettings.source;
      }
      $scope.stop();
      jobEvent();
      currentSelectedRowReqEvent();
      currentSelectedGroupEvent();
      try {
        destroyLastLocationCtxMenu();
      } catch (err) {
        console.log(err);
      }

      updateRequest();
    });

    function destroyLastLocationCtxMenu() {
      $('#'+$scope.uuidForElement+'_betoTrack_fmsVehicleCtx').unbind('itemclick', fmsVehicleListContextHandler);
      $('#'+$scope.uuidForElement+'_betoTrack_fmsVehicleCtx').jqxMenu('destroy');
    }

  }).controller('FMSVehicleEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {
    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '20', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/fmsVehicle/fmsVehicleWidget.js